import { useUIStore } from "../../../../store";
// Importamos los iconos de Font Awesome (los más estables)
import { FaSun, FaMoon } from 'react-icons/fa';
import styles from './IconLightDark.module.scss'

export const IconLightDark = () => {
  const theme = useUIStore((state) => state.theme);
  const lang = useUIStore((state) => state.lang);
  const translations = useUIStore((state) => state.translations);

  const toggleTheme = useUIStore((state) => state.toggleTheme);
  const setLang = useUIStore((state) => state.setLang);

  // Lógica del Ícono: Si es 'dark', mostramos el Sol (para cambiar a light).
  const ThemeIcon = theme === "dark" ? FaSun : FaMoon;

  // Texto de Accesibilidad y Tooltip (crucial al no haber texto visible)
  const nextThemeText = theme === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro";

  // Color del ícono para asegurar el contraste visual
  const iconColor = theme === "dark" ? "white" : "black";

  return (
    <button
      onClick={toggleTheme}
      aria-label={nextThemeText} // Para lectores de pantalla
      title={nextThemeText}
      className={styles.buttonIconLightDark}     // Tooltip (texto al pasar el ratón)
    >
      <ThemeIcon />
    </button>

  );
};